import { advancedFilterCondition, lookupRouteName } from 'common/constants';
import { FilterParams } from 'core/models';
import { observable, action, runInAction, makeObservable, toJS } from 'mobx';
import { notificationError, isSome, isWarehouse, isSeller, isSuperAdminOrganization } from 'core/utils';
import { CoreUserService } from 'common/data';
import moment from 'moment';
import _ from 'lodash';

class TableFilterUtility {
	@observable visible = false;
	@observable targetElement = null;
	@observable top = 0;
	@observable left = 0;
	@observable tableWrap = 0;
	@observable startLeftValue = 0;
	@observable startBottomValue = 0;
	column;

	constructor(props) {
		makeObservable(this);
		const { lookupStore, listStore, queryUtility, columns, services } = props;
		this.listStore = listStore;
		this.lookupStore = lookupStore;
		this.rootStore = lookupStore.rootStore;
		this.queryUtility = queryUtility;
		this.columns = columns;
		this.services = services;
		this.coreUserService = new CoreUserService(this.rootStore.app.baasic.apiClient);
		runInAction(() => {
			this.column = null;
		});
	}

	@action.bound calculatePopupPosition() {
		const { x, y, height, width, right, bottom } = this.targetElement.getClientRects()[0];
		this.top = y + height;
		this.left = x;
		var leftVal = this.left;
		this.startBottomValue = bottom + 520;
		this.tableWrap = document.getElementsByClassName('k-widget k-grid')[0]
			? document.getElementsByClassName('k-widget k-grid')[0]
			: document.getElementsByClassName('table__wrap--nopager')[0];
		this.bottomCoordinate = window.innerHeight;
		if (this.tableWrap != undefined) {
			if (this.startLeftValue > this.tableWrap.clientWidth / 2) {
				if (right > this.tableWrap.clientWidth + 250) {
					leftVal -=
						300 -
						width +
						(right - (this.tableWrap.offsetWidth + 250)) +
						(this.tableWrap.offsetWidth - this.tableWrap.clientWidth);
				} else {
					leftVal -= 300 - width;
				}
			}
			if (this.startBottomValue > this.bottomCoordinate) {
				this.top = y - (520 + height);
			}
		}
		this.left = leftVal;
	}

	@action.bound onTableFilter(column, targetElement) {
		if (this.visible) {
			this.visible = false;
		} else {
			this.targetElement = targetElement;
			const { x, y, height, width, right, bottom } = this.targetElement.getClientRects()[0];
			this.top = y + height;
			this.left = x;
			var leftVal = this.left;
			this.startLeftValue = this.left - 250;
			this.startBottomValue = bottom + 520;
			this.tableWrap = document.getElementsByClassName('k-widget k-grid')[0]
				? document.getElementsByClassName('k-widget k-grid')[0]
				: document.getElementsByClassName('table__wrap--nopager')[0];
			this.bottomCoordinate = window.innerHeight;
			if (this.tableWrap != undefined) {
				if (this.startLeftValue > this.tableWrap.clientWidth / 2) {
					if (right > this.tableWrap.clientWidth + 250) {
						leftVal -=
							300 -
							width +
							(right - (this.tableWrap.offsetWidth + 250)) +
							(this.tableWrap.offsetWidth - this.tableWrap.clientWidth);
					} else {
						leftVal -= 300 - width;
					}
				}
				if (this.startBottomValue > this.bottomCoordinate) {
					this.top = y - (520 + height);
				}
			}
			this.left = leftVal;
			this.column = { ...column };
			this.visible = true;
		}
	}

	find = async (search, sellerId) => {
		// Mind the dotted lookup property fields (e.g. channel.label)
		search = search.trim();
		let key = this.column.dontSplit ? this.column.key : this.column.key.split('.')[0];
		let checkPartiallyFulfillMixedOrders = this.column.checkPartiallyFulfillMixedOrders;
		const embed = ['productUpcs'].includes(key) ? [key] : null;
		const keySingular = key.slice(0, -1);
		const hasLookupConst = isSome(this.column.lookupConstant);
		const hasService = isSome(this.column.service);
		const isUserFilter = this.column.key == 'userName';
		const filterKey = this.column.filterKey;
		const isLookup = this.column.lookupConstant != null;
		if (keySingular in lookupRouteName) {
			key = keySingular;
		}
		let filter = new FilterParams();
		let response = null,
			retVal = null;
		if (hasLookupConst) {
			filter = Object.assign(filter, {
				search: search != '' ? search.replace(/"/g, '') : null,
				orderBy: 'name',
				orderDirection: 'asc',
			});
			if (key === 'onHoldReason') {
				filter.showUserFilter = false;
			}
			response = await this.lookupStore.getLookupService(this.column.lookupConstant).find(filter);
			var assignedStatus = response.data.item.find(i => i.abrv === 'assigned');
			var pickingStatus = response.data.item.find(i => i.abrv === 'picking');
			// For bulk print mode, display only assigned and picking status as filter option.
			if (
				this.rootStore.orderListViewStore &&
				this.rootStore.orderListViewStore.isBulkPrintMode &&
				_.isArray(response.data.item)
			) {
				response.data.item = _.filter(response.data.item, item => {
					return item.abrv === assignedStatus.abrv || item.abrv === pickingStatus.abrv;
				});
			}
			// Tax code special case, in back-end too
			if (_.isArray(response.data) && response.data.length) {
				response = {
					...response,
					data: {
						item: response.data.map(item => {
							return { name: item };
						}),
					},
				};
			}
		} else if (hasService) {
			const serviceIdx = _.findIndex(this.services, item => {
				return item.constructor.name.toLowerCase() == this.column.service.toLowerCase();
			});

			if (this.column.checkForWarehouseLogin) {
				var isWarehouseUser = isWarehouse(this.rootStore);
			}
			const userOrgSeller = isSeller(this.rootStore);
			const splitColumnKey = key.split('.');
			filter = Object.assign(filter, {
				embed: isUserFilter ? ['coreUser'] : null,
				isDeleted: this.column.isDeleted,
				searchFields: filterKey
					? filterKey
					: splitColumnKey.length == 1
					? key
					: splitColumnKey[splitColumnKey.length - 1],
				search: search != '' ? search.replace(/"/g, '') : null,
				orderBy:
					this.column.filterKey != null
						? this.column.filterKey
						: _.includes(key, '.')
						? _.upperFirst(_.last(_.split(key, '.')))
						: _.upperFirst(key),
				orderDirection: 'asc',
				isWarehouse: isWarehouseUser,
				sellerOnly: this.column.sellerOnly,
				warehouseOnly: this.column.isWarehouseOnlyColumn,
				isSortingOfUnlinkedNeeded: key === 'order.shippingZipCode' ? false : true,
				ignoreOrganizationId:
					key === 'pallet'
						? userOrgSeller
							? true
							: isWarehouseUser
							? key === 'order.shippingCity' || key === 'order.shippingZipCode'
							: false
						: false,
				sellerIds:
					sellerId == null && (isSuperAdminOrganization(this.rootStore) || isWarehouse(this.rootStore))
						? []
						: [sellerId || this.rootStore.applicationStore.currentOrganization.id],
				excludeShipmentsWithNoCarrier: true,
				ignoreEmptyTracking: true,
				shippedOnly: this.column.shippedOnly,
			});
			if (key === 'orderNumber' || key === 'fulfillmentOrder.order.orderNumber' || key === 'order.orderNumber') {
				filter.checkPartiallyFulfillMixedOrders = checkPartiallyFulfillMixedOrders;
			}
			if (key === 'onHoldReason') {
				filter.showUserFilter = false;
			}
			response = await this.services[serviceIdx].find(filter);
		} else {
			if (isLookup) {
				filter.embed = [key];
			}
			filter = Object.assign(filter, {
				embed: embed,
				isDeleted: this.column.isDeleted,
				searchFields: [key],
				search: search != '' ? search.replace(/"/g, '') : null,
				orderBy: key,
				orderDirection: 'asc',
				sellerIds:
					sellerId == null && (isSuperAdminOrganization(this.rootStore) || isWarehouse(this.rootStore))
						? []
						: [sellerId || this.rootStore.applicationStore.currentOrganization.id],
				isWarehouse: isWarehouse,
			});
			if (key === 'orderNumber') {
				filter.checkPartiallyFulfillMixedOrders = checkPartiallyFulfillMixedOrders;
			}
			if (key === 'onHoldReason') {
				filter.showUserFilter = false;
			}
			response = await this.services[0].find(filter);
		}
		if (response && response.data && response.data.item && response.data.item.length) {
			if (isLookup) {
				if (!hasLookupConst) {
					// Should not happen really, but make it proper anyways (unique).
					retVal = _.uniq(_.map(response.data.item, item => (_.has(item, key) ? _.get(item, `${key}.label`) : null)));
				} else {
					retVal = _.map(
						response.data.item,
						item =>
							_.has(item, 'name') ? (key === 'searchKeyword' ? _.get(item, keyword) : _.get(item, 'name')) : null
						//_.has(item, 'id') ? (key === 'searchKeyword' ? _.get(item, keyword) : _.get(item, 'id')) : null
					);
				}
			} else if (isUserFilter) {
				retVal = _.map(response.data.item, item => item.coreUser.displayName.split('-')[0]);
			} else {
				if (this.column.type === 'address') {
					retVal = _.uniq(
						_.map(response.data.item, item => {
							let address = '';
							_.each(this.column.composition, (compositionKey, idx) => {
								address = address.concat(idx === 0 ? _.get(item, compositionKey) : `, ${_.get(item, compositionKey)}`);
							});
							return address === '' ? undefined : address;
						})
					);
				} else {
					// Group results, eliminate duplicates
					var searchListValues = [];
					const path = filterKey ? filterKey.split('.') : key.split('.');
					const subPath = [this.column.key.split('.')[1]];
					_.each(response.data.item, item => {
						this.findObjectForObservation(item, 0, [path[path.length - 1]], searchListValues, subPath);
					});
					retVal = _.uniq(searchListValues);
				}
			}
		}
		// Remove empty values
		return retVal ? _.compact(retVal) : null;
	};

	findObjectForObservation = (item, currentKeyIndex, path, finalArray, subPath) => {
		if (_.isArray(_.get(item, path[currentKeyIndex]))) {
			var currentArray = _.get(item, path[currentKeyIndex]);
			_.each(currentArray, arrayObject => {
				this.findObjectForObservation(arrayObject, 0, subPath, finalArray);
			});
		} else if (this.column.filterKey) {
			finalArray.push(_.get(item, this.column.filterKey));
		} else {
			finalArray.push(_.get(item, _.slice(path, currentKeyIndex)));
		}
	};

	remove = async () => {
		// Remove current column filter.
		this.column.filter = null;
		// Remove old filter data from local storage.
		let columnFilterIndex = _.findIndex(this.columns, element => {
			return element.key === this.column.key;
		});
		if (columnFilterIndex > -1) {
			this.columns[columnFilterIndex].filter = null;
		}
		this.visible = false;
		await this.update();
	};

	removeAll = async (initialize = true) => {
		// Remove all filters.
		_.forEach(this.columns, (column, key, col) => {
			column.filter = null;
			col[key] = column;
		});
		runInAction(() => {
			this.visible = false;
			// Remove old filter.
			delete this.queryUtility.filter.advancedSearch;
		});
		if (initialize) {
			try {
				this.queryUtility.initialize(false);
			} catch (err) {
				notificationError({ store: this.rootStore.notificationStore, err });
				delete this.queryUtility.filter.advancedSearch;
				// NOTE: This can still break into "internal error" handler due to different error
				this.queryUtility.initialize(false);
			}
		}
	};

	update = async () => {
		const { filter, key } = this.column;
		let advancedSearch = [];
		let oldAdvancedSearch = this.queryUtility.filter.advancedSearch;
		let currentFilterElements = oldAdvancedSearch ? [...oldAdvancedSearch] : [];
		if (currentFilterElements) {
			_.remove(
				currentFilterElements,
				filterElement =>
					filterElement.fieldName === key ||
					(key === 'fulfillmentOrderId' && filterElement.fieldName === 'onHoldReasonId') ||
					key === 'referenceNumber'
			);
		}
		if (filter && filter.hasErrors) {
			const hasErrorsFilterElement = {
				condition: advancedFilterCondition.NotEquals,
				fieldName: 'onHoldReasonId',
				filterValue: [{ value: null }],
			};
			currentFilterElements.push(hasErrorsFilterElement);
		}
		if (filter && filter.freeType) {
			const freeTypeFilterElement = {
				condition: advancedFilterCondition.Contains,
				fieldName: key,
				filterValue: [{ value: filter.freeType }],
			};
			currentFilterElements.push(freeTypeFilterElement);
		}
		if (filter && filter.selected) {
			const selectedFilterElement = {
				condition: advancedFilterCondition.In,
				fieldName: key,
				filterValue: filter.selected.map(value => {
					return { Value: value };
				}),
				useAlias: this.column.useAlias,
			};

			if (filter.selected.slice().length) {
				currentFilterElements.push(selectedFilterElement);
			}
		}
		if (filter && filter.specificDate) {
			const specificDateFilterElement = {
				condition: advancedFilterCondition.Equals,
				fieldName: key,
				filterValue: [{ value: moment(filter.specificDate).format('YYYY/MM/DD') }],
			};
			currentFilterElements.push(specificDateFilterElement);
		}
		if (filter && filter.dateRangeStart && filter.dateRangeEnd) {
			const rangeStartFilterElement = {
				condition: advancedFilterCondition.GreaterEqual,
				fieldName: key,
				filterValue: [{ value: moment(filter.dateRangeStart).format('YYYY/MM/DD') }],
			};
			const rangeEndFilterElement = {
				condition: advancedFilterCondition.LesserEqual,
				fieldName: key,
				filterValue: [{ value: moment(filter.dateRangeEnd).format('YYYY/MM/DD') }],
			};
			currentFilterElements.push(rangeStartFilterElement, rangeEndFilterElement);
		}
		if (filter && filter.specificNumber) {
			const specificNumberFilterElement = {
				condition: advancedFilterCondition.In,
				fieldName: key,
				filterValue: [{ value: filter.specificNumber }],
			};

			currentFilterElements.push(specificNumberFilterElement);
		}
		if (filter && (filter.numberRangeStart || filter.numberRangeEnd)) {
			const numberRangeStartFilterElement = {
				condition: advancedFilterCondition.GreaterEqual,
				fieldName: key,
				filterValue: [{ value: filter.numberRangeStart }],
			};
			const numberRangeEndFilterElement = {
				condition: advancedFilterCondition.LesserEqual,
				fieldName: key,
				filterValue: [{ value: filter.numberRangeEnd }],
			};
			currentFilterElements.push(numberRangeStartFilterElement, numberRangeEndFilterElement);
		}
		advancedSearch = currentFilterElements;
		this.queryUtility.filter.advancedSearch = advancedSearch;
		try {
			this.queryUtility.initialize(false);
		} catch (err) {
			notificationError({ store: this.rootStore.notificationStore, err });
			delete this.queryUtility.filter.advancedSearch;
			// NOTE: This can still break into "internal error" handler due to different error
			this.queryUtility.initialize(false);
		}
	};
}

export default TableFilterUtility;



// WEBPACK FOOTER //
// ./src/core/utils/TableFilterUtility.js